<template>
  <div id="settings-dial">
    <v-speed-dial v-model="fab" left fixed bottom direction="right" transition="slide-x-transition">
      <template v-slot:activator>
        <v-btn v-model="fab" color="grey lighten-2" dark fab small>
          <v-icon color="red darken-1" v-if="fab">mdi-close</v-icon>
          <v-icon v-else color="grey darken-1">mdi-cog</v-icon>
        </v-btn>
      </template>
      <v-btn
        fab
        dark
        small
        v-for="(lang, i) in langs"
        color="grey lighten-3"
        :key="i"
        @click="setLocale(lang.lang)"
      >
        <img class="h-5 w-5" :src="lang.src" :alt="lang.lang" />
      </v-btn>

      <v-btn @click="$vuetify.theme.dark = !$vuetify.theme.dark;" fab dark small color="blue">
        <v-icon>mdi-theme-light-dark</v-icon>
      </v-btn>
    </v-speed-dial>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fab: false,
      langs: [
        { src: require("@/assets/flags/de.svg"), lang: "de" },
        { src: require("@/assets/flags/en.svg"), lang: "en" }
        // { src: require("@/assets/flags/jp.svg"), lang: "jp" },
        // { src: require("@/assets/flags/es.svg"), lang: "es" },
        // { src: require("@/assets/flags/fr.svg"), lang: "fr" }
      ]
    };
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.$router.push({
        params: { lang: locale }
      });
      this.hide;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>